import { Link } from 'gatsby';
import React from 'react';

const Item = ({ link, title }) => {
  const classes =
    'ml-0 font-semibold text-gray-300 transition duration-150 ease-in-out hover:text-white focus:outline-none focus:text-white text-xs uppercase';

  return /^http/.test(link) ? (
    <a href={link} target="_blank" rel="noreferrer" className={classes}>
      {title}
    </a>
  ) : (
    <Link to={link} className={classes}>
      {title}
    </Link>
  );
};

export default Item;
